export { MemoizedAvailabilitySlot as AvailabilitySlot } from './AvailabilitySlot';
